export default "__VITE_ASSET__BoyOWcYp__"